module.exports = __webpack_public_path__ + "static/media/oliver1932.b30e5e0c.png";